import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface BackendUnavailableMessageProps {
  onRetry?: () => void;
  contractId?: string;
}

export const BackendUnavailableMessage: React.FC<
  BackendUnavailableMessageProps
> = ({ onRetry, contractId }) => {
  return (
    <Card className="w-full max-w-2xl mx-auto">
      <CardHeader className="text-center">
        <div className="flex justify-center mb-4">
          <AlertTriangle className="h-16 w-16 text-yellow-500" />
        </div>
        <CardTitle className="text-xl text-yellow-700">
          Backend Services Unavailable
        </CardTitle>
      </CardHeader>
      <CardContent className="text-center space-y-4">
        <p className="text-gray-600">
          The negotiation system is currently experiencing technical
          difficulties. Some features may not be available.
        </p>

        {contractId && (
          <div className="bg-gray-100 p-3 rounded-lg">
            <p className="text-sm text-gray-700">
              <strong>Contract ID:</strong> {contractId}
            </p>
          </div>
        )}

        <div className="space-y-2">
          <p className="text-sm text-gray-600">This may be due to:</p>
          <ul className="text-sm text-gray-600 text-left max-w-md mx-auto">
            <li>• Backend services are starting up</li>
            <li>• Database connection issues</li>
            <li>• API endpoint configuration problems</li>
          </ul>
        </div>

        {onRetry && (
          <Button onClick={onRetry} className="mt-4" variant="outline">
            <RefreshCw className="h-4 w-4 mr-2" />
            Retry
          </Button>
        )}

        <p className="text-xs text-gray-500 mt-4">
          Please try refreshing the page or contact support if the issue
          persists.
        </p>
      </CardContent>
    </Card>
  );
};
